import { parseLanguageTag, LanguageTag } from '@phensley/language-tag';
import { LanguageResolver } from './resolver';
var UNDEFINED = new LanguageTag();
/**
 * Merged declaration to add a parse() method to Locale interface.
 *
 * @public
 */
var Locale = /** @class */ (function () {
    function Locale() {
    }
    /**
     * Parses a language tag and resolves it, substituting aliases and
     * adding likely subtags.
     */
    Locale.resolve = function (id) {
        var tag = parseLanguageTag(id);
        if (tag.hasLanguage() || tag.hasScript() || tag.hasRegion()) {
            tag = LanguageResolver.resolve(tag);
        }
        else {
            tag = UNDEFINED;
        }
        return { id: id, tag: tag };
    };
    return Locale;
}());
export { Locale };
